import {
  GET_TARGET_DOMAIN_LIST_FULFILLED,
  SELECT_TARGET_DOMAIN,
  GET_TARGET_DOMAIN_FULFILLED,
  GET_TARGET_DOMAIN_PENDING,
  TargetDomainActionTypes,
  TargetDomainState,
  CREATE_TARGET_DOMAIN_PENDING,
  CREATE_TARGET_DOMAIN_FULFILLED,
} from './targetDomain.types';
import { adaptTargetDomainList, adaptSelectedTargetDomain } from './targetDomain.adapter';

const initialState: TargetDomainState = {
  entities: [],
  select: [],
  createdId: null,
  single: null,
};

export default function xdpReducer(
  state = initialState,
  action: TargetDomainActionTypes,
): TargetDomainState {
  switch (action.type) {
    case GET_TARGET_DOMAIN_LIST_FULFILLED:
      return { ...state, entities: adaptTargetDomainList(action.payload.data.data || []) };

    case SELECT_TARGET_DOMAIN:
      return { ...state, select: adaptSelectedTargetDomain(action.payload || []) };

    case GET_TARGET_DOMAIN_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_TARGET_DOMAIN_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case CREATE_TARGET_DOMAIN_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_TARGET_DOMAIN_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated || action.payload.data.data?.[0].domain || null,
      };

    default:
      return state;
  }
}
